import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://backend.mystore.education/api";

export const fetchTeachersCodes = createAsyncThunk(
  "teachers_codes/fetchTeachersCodes",
  async (params = 1, { rejectWithValue }) => {
    try {
      const page = typeof params === "object" ? (params.page ?? 1) : params;
      const teacher_id = params.teacher_id ?? "";
      const grade_id = params.grade_id ?? "";
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      let url = `${BASE_URL}/dashboard/teachers-codes?page=${page}`;
      if (teacher_id) url += `&teacher_id=${teacher_id}`;
      if (grade_id) url += `&grade_id=${grade_id}`;
      
      const response = await axios.get(
        url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed load data";
      return rejectWithValue(message);
    }
  }
);

// fetch teachers_codes filtered by teacher_id and/or grade_id (to link with a product)
export const fetchTeachersCodesByProduct = createAsyncThunk(
  "teachers_codes/fetchByProduct",
  async ({ teacher_id = "", grade_id = "", page = 1 } = {}, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      let url = `${BASE_URL}/dashboard/teachers-codes?page=${page}`;
      if (teacher_id) url += `&teacher_id=${teacher_id}`;
      if (grade_id) url += `&grade_id=${grade_id}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept-Language": "ar",
        },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed load data";
      return rejectWithValue(message);
    }
  }
);


// add teachers_codes
export const addTeachersCodes = createAsyncThunk(
  "teachers_codes/add",
  async (userData, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/teachers-codes`,
        userData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تمت الإضافة بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في إضافة الصف";
      return rejectWithValue(message);
    }
  }
);
// get teachers_codes record
export const teachersCodesRecord = createAsyncThunk(
  "teachers_codes/teachersCodesRecord",
  async (id, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.get(`${BASE_URL}/dashboard/teachers-codes/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحميل بيانات الصف";
      return rejectWithValue(message);
    }
  }
);
// update teachers_codes
export const updateTeachersCodes = createAsyncThunk(
  "teachers_codes/updateTeachersCodes",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/teachers-codes/${id}/update`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تم التحديث بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحديث الصف";
      return rejectWithValue(message);
    }
  }
);

// import teachers_codes
export const importTeacherCodes = createAsyncThunk(
  "teachers_codes/import",
  async (formData, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/teachers-codes/import`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تم رفع الملف بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في رفع الملف";
      return rejectWithValue(message);
    }
  }
);
// delete teachers_codes
export const deleteTeachersCodes = createAsyncThunk(
  "teachers_codes/deleteTeachersCodes",
  async (id, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.delete(
        `${BASE_URL}/dashboard/teachers-codes/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في حذف الصف";
      return rejectWithValue(message);
    }
  }
);
const TeachersCodesSlice = createSlice({
  name: "teachers_codes",
  initialState: {
    teachers_codes: [],
    record: null,
    meta: null,
    isLoading: false,
    error: null,
    success: null,
    // لأكواد مرتبطة بمنتج محدد
    productCodes: [],
    productCodesMeta: null,
    productCodesLoading: false,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeachersCodes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTeachersCodes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.meta = action.payload.meta;
        state.teachers_codes = action.payload;
        state.meta = action.payload.meta;
      })
      .addCase(fetchTeachersCodes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load data";
      })
      .addCase(addTeachersCodes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addTeachersCodes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(addTeachersCodes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to add data";
      })
      .addCase(teachersCodesRecord.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(teachersCodesRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.record = action.payload.data;
      })
      .addCase(teachersCodesRecord.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to add data";
      })
      .addCase(updateTeachersCodes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateTeachersCodes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(updateTeachersCodes.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          "Failed to update record";
      })
      .addCase(importTeacherCodes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(importTeacherCodes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(importTeacherCodes.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          "Failed to import file";
      })
      .addCase(deleteTeachersCodes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteTeachersCodes.fulfilled, (state, action) => {
        state.isLoading = false;

        // Remove from data array inside teachers_codes
        if (state.teachers_codes?.data) {
          state.teachers_codes.data = state.teachers_codes.data.filter(
            (record) => record.id !== action.meta.arg
          );
        }

        state.success = action.payload?.message || "Deleted successfully";
      })
      .addCase(deleteTeachersCodes.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          action.error?.message ||
          "Failed to delete teachers_codes";
      })
      // fetchTeachersCodesByProduct
      .addCase(fetchTeachersCodesByProduct.pending, (state) => {
        state.productCodesLoading = true;
        state.error = null;
      })
      .addCase(fetchTeachersCodesByProduct.fulfilled, (state, action) => {
        state.productCodesLoading = false;
        state.productCodes = action.payload?.data || [];
        state.productCodesMeta = action.payload?.meta || null;
      })
      .addCase(fetchTeachersCodesByProduct.rejected, (state, action) => {
        state.productCodesLoading = false;
        state.error = action.payload || "Failed to load codes";
      });
  },
});

export const { clearState } = TeachersCodesSlice.actions;
export default TeachersCodesSlice.reducer;
